import { CardPaymentType, Pageable, PaymentMethodType } from '@kinderlabs-pos/shared-data-type';
import { Dayjs } from 'dayjs';

export const paymentExcelDownloadUrl =
	(rootUrl: string) =>
	({
		dataOnPage = false,
		method,
		cardPaymentType,
		amount,
		bin,
		status,
		storeIdList,
		posId,
		from,
		to,
		search,
		pageable,
	}: PaymentExcelRequestType) => {
		const url = new URL(`${rootUrl}/excel/payment/${dataOnPage ? 'page' : 'all'}`);
		if (method) url.searchParams.append('method', method);
		if (cardPaymentType) url.searchParams.append('cardPaymentType', cardPaymentType);
		if (amount) url.searchParams.append('amount', `${amount}`);
		if (bin) url.searchParams.append('bin', bin);
		if (status) url.searchParams.append('status', status);
		if (storeIdList) url.searchParams.append('storeIdList', `${storeIdList}`);
		if (posId) url.searchParams.append('targetPosId', `${posId}`);
		if (from) url.searchParams.append('from', from.format('YYYY-MM-DD HH:mm:ss'));
		if (to) url.searchParams.append('to', to.format('YYYY-MM-DD HH:mm:ss'));
		if (search) url.searchParams.append('search', search);
		if (pageable.page) url.searchParams.append('page', `${pageable.page}`);
		if (pageable.size) url.searchParams.append('size', `${pageable.size}`);
		if (pageable.sort)
			url.searchParams.append('sort', `${pageable.sort.name},${pageable.sort.direction}`);

		return `${url}`;
	};

export type PaymentExcelRequestType = {
	dataOnPage?: boolean;
	from: Dayjs;
	to: Dayjs;
	pageable: Pageable;
	method?: PaymentMethodType;
	cardPaymentType?: CardPaymentType;
	amount?: number;
	bin?: string;
	status?: 'REFUND' | 'COMPLETE';
	storeIdList?: number[];
	posId?: number;
	search?: string;
};
